export class Paycheck {
  accountReceivableId: number;
  name: string;
  incomeType: string;
  paycheckDate: Date;
  nextPaycheckDate: Date;
  amount: number;
  netIncome: number;
}
